<template>
  <v-dialog hide-overlay max-width="600px" transition="dialog-bottom-transition" v-model="show">
    <v-card tile>
      <v-card-title>
        <v-toolbar-title>資料ダウンロード</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn @click="downloadExcel">download</v-btn>
          <v-btn @click="close" icon>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-card-title>

      <v-card-text>
        <v-radio-group v-model="radioGroup">
          <v-radio key="1" label="受入確認照会機種別" value="acceptance"></v-radio>
          <v-radio key="2" label="機種別諸掛" value="sku"></v-radio>
          <v-radio key="3" label="ETAから１週間経過" value="eta"></v-radio>
          <v-radio key="4" label="SYTC着荷計画書" value="sytc"></v-radio>
          <v-radio key="5" label="コンテナ別受入確認照会" value="container"></v-radio>
        </v-radio-group>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["shipments"],
  data() {
    return { show: false, radioGroup: "" };
  },
  methods: {
    popup() {
      this.show = true;
    },
    close() {
      this.$emit("closeEvent", false);
    },
    downloadExcel() {
      switch (this.radioGroup) {
        case "acceptance":
          this.acceptanceDownload();
          break;
        case "sku":
          this.skuDownload();
          break;
        case "eta":
          this.etaDownload();
          break;
        case "sytc":
          this.sytcDownload();
          break;
        case "container":
          this.containerDownload();
          break;
      }
    },
    acceptanceDownload() {
      let packages = [];
      this.shipments.forEach(s => {
        s.packages.forEach(p => {
          p = { ...p, ...s };
          packages.push(p);
        });
      });
      let headers = [
        "skuCode",
        "productCode",
        "finallyWarehouseName",
        "forecastDeliveryDate",
        "forecastDeliveryTime",
        "totalQty", //todo
        "status",
        "doNo",
        "partnerName",
        "invoiceNo", //todo
        "eta",
        "dischargePortName",
        "containerNo",
        "containerTypeCode",
        "",
        "",
        "",
        ""
      ];
      let showHeaders = [
        "P/N",
        "品種名",
        "最新 納入指示納入場所",
        "最新 納入指示予定日",
        "最新 納入指示予定時間",
        "QTY",
        "状況",
        "DONo",
        "SHIPPER",
        "INVOICE NO",
        "ETA",
        "TO",
        "ｺﾝﾃﾅ No",
        "ｺﾝﾃﾅｻｲｽﾞ",
        "納入指示者希望日",
        "納入指示者希望納入場所",
        "第一受入確認者確定日",
        "第一受入確認者確定納入場所"
      ];
      this.$exportTable(packages, headers, showHeaders, "invoices");
      this.show = false;
    },
    skuDownload() {
      let packages = [];
      this.shipments.forEach(s => {
        s.packages.forEach(p => {
          console.log(p);
          p = {
            ...p,
            ...s,
            externalFee: s.summaryCharges
              .filter(c => c.chargeItemCode == "SEA-001")
              .filter(c => c.subTotal != null)
              .map(c => c.subTotal)
              .reduce((t, c) => {
                return (t += c);
              }, 0),
            currencyRate: s.summaryCharges
              .filter(c => c.chargeItemCode == "SEA-001")
              .map(c => c.currencyRate)[0],
            jpyTotal: s.summaryCharges
              .filter(c => c.chargeItemCode == "SEA-001")
              .filter(c => c.jpySubTotal != null)
              .map(c => c.jpySubTotal)
              .reduce((t, c) => {
                return (t += c);
              }, 0),
            internalFee: s.summaryCharges
              .filter(c => c.chargeItemCode == "LOCAL-001")
              .filter(c => c.jpySubTotal != null)
              .map(c => c.jpySubTotal)
              .reduce((t, c) => {
                return (t += c);
              }, 0),
            ccFee: s.summaryCharges
              .filter(c => c.chargeItemCode == "LOCAL-006")
              .filter(c => c.jpySubTotal != null)
              .map(c => c.jpySubTotal)
              .reduce((t, c) => {
                return (t += c);
              }, 0),
            deliveryFee: s.summaryCharges
              .filter(c => c.chargeItemCode == "LOCAL-004")
              .filter(c => c.jpySubTotal != null)
              .map(c => c.jpySubTotal)
              .reduce((t, c) => {
                return (t += c);
              }, 0),
            handlingFee: "",
            toll: s.summaryCharges
              .filter(c => c.chargeItemCode == "LOCAL-007")
              .filter(c => c.jpySubTotal != null)
              .map(c => c.jpySubTotal)
              .reduce((t, c) => {
                return (t += c);
              }, 0),
            otherCharge1: s.summaryCharges
              .filter(c => c.chargeItemCode == "LOCAL-024")
              .filter(c => c.jpySubTotal != null)
              .map(c => c.jpySubTotal)
              .reduce((t, c) => {
                return (t += c);
              }, 0),
            otherCharge2: s.summaryCharges
              .filter(c => c.chargeItemCode == "LOCAL-025")
              .filter(c => c.jpySubTotal != null)
              .map(c => c.jpySubTotal)
              .reduce((t, c) => {
                return (t += c);
              }, 0),
            commission: s.summaryCharges
              .filter(
                c =>
                  c.chargeItemCode == "SEA-012" || c.chargeItemCode == "AIR-009"
              )
              .filter(c => c.jpySubTotal != null)
              .map(c => c.jpySubTotal)
              .reduce((t, c) => {
                return (t += c);
              }, 0)
          };
          packages.push(p);
        });
      });
      let headers = [
        "skuCode",
        "doNo",
        "blNo",
        "containerNo",
        "partnerName",
        "buHeadquartersName",
        "departmentName",
        "loadingPortName",
        "etd",
        "dischargePortName",
        "eta",
        "finallyWarehouseName",
        "skuType",
        "departmentCode",
        "externalFee",
        "currencyRate",
        "jpyTotal",
        "internalFee",
        "deliveryFee",
        "ccFee",
        "handlingFee",
        "toll",
        "otherCharge1",
        "otherCharge2",
        "commission",
        "納品書NO",
        "poNo",
        "lotNo",
        "",
        "納入数"
      ];
      let showHeaders = [
        "社内品番",
        "D/O No",
        "B/L No",
        "コンテナNo",
        "海外取引先",
        "事業本部",
        "事業部",
        "積出港",
        "ETD",
        "陸揚港",
        "ETA",
        "納入場所コード",
        "物品区分",
        "部門コード",
        "海上航空運賃",
        "換算レート",
        "海上航空運賃円換算",
        "国内運賃",
        "搬出手数料",
        "C.C.FEE",
        "取扱料",
        "通関料",
        "その他追加費用1",
        "その他追加費用2",
        "SJL Commission",
        "納品書NO",
        "PONO",
        "LOTNO",
        "",
        "納入数"
      ];
      this.$exportTable(packages, headers, showHeaders, "sku");
      this.show = false;
    },
    etaDownload() {
      let packages = [];
      this.shipments.forEach(s => {
        s.packages.forEach(p => {
          p = { ...p, ...s };
          packages.push(p);
        });
      });
      let headers = [
        "dischargePortCode",
        "dischargePortName",
        "containerNo",
        "doNo",
        "masterBlNo",
        "houseBlNo", //todo
        "paid",
        "partnerCode",
        "partnerName",
        "invoiceNo", //todo
        "buHeadquartersCode",
        "buHeadquartersName",
        "departmentCode",
        "departmentName",
        "warehouseOperatorName",
        "finallyWarehouseName",
        "shipName",
        "blIssueDate",
        "eta",
        "eta",
        "",
        "currencyCode",
        "productName",
        "incotermCode",
        "status",
        "",
        ""
      ];
      let showHeaders = [
        "陸揚港",
        "港名",
        "CONTAINERNO",
        "DONO",
        "BLNO",
        "BLNO(NACCS)",
        "有償無償",
        "海外取引先",
        "海外取引先名",
        "事業本部_",
        "事業本部名_",
        "事業部_",
        "事業部名_",
        "担当者名",
        "乙仲",
        "船名フライトNO",
        "BL発行日",
        "ETA",
        "ATA(NACCS)",
        "NACCS許可日",
        "通貨コード",
        "代表品種名",
        "支払方法",
        "DO状況(通関)",
        "仕入計上日",
        "納入指示"
      ];
      this.$exportTable(packages, headers, showHeaders, "eta");
      this.show = false;
    },
    sytcDownload() {
      let packages = [];
      this.shipments.forEach(s => {
        s.packages.forEach(p => {
          p = { ...p, ...s };
          packages.push(p);
        });
      });
      let headers = [
        "etd",
        "eta",
        "containerNo",
        "containerTypeCode",
        "skuName",
        "productName", //todo
        "skuCode",
        "skuCode",
        "skuName",
        "totalQty", //todo
        "lotNo",
        "invoiceNo",
        "forecastDeliveryDate",
        "departmentName",
        "warehouseOperatorName",
        "finallyWarehouseName",
        "finallyWarehouseName",
        "",
        "",
        "",
        ""
      ];
      let showHeaders = [
        "ETD",
        "ETA",
        "コンテナNo.",
        "サイズ",
        "機種名",
        "品種名",
        "社内部品コード",
        "社外部品コード",
        "部品名称",
        "事業本部_",
        "納入数量",
        "LOT No.",
        "INV No.",
        "搬入日時",
        "搬入場所",
        "判定日付",
        "判定結果",
        "印",
        "責任者"
      ];
      this.$exportTable(packages, headers, showHeaders, "sytc");
      this.show = false;
    },
    containerDownload() {
      let packages = [];
      this.shipments.forEach(s => {
        s.packages.forEach(p => {
          p = { ...p, ...s };
          packages.push(p);
        });
      });
      let headers = [
        "status",
        "doNo",
        "partnerName",
        "invoiceNo",
        "eta",
        "dischargePortCode", //todo
        "volNo",
        "containerNo",
        "containerTypeCode",
        "blNo", //todo
        "poNo",
        "productName",
        "totalQty",
        "forecastDeliveryDate",
        "forecastDeliveryTime",
        "sjlWarehouseName",
        "warehousingDate",
        "warehousingTime",
        "finallyWarehouseName",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        ""
      ];
      let showHeaders = [
        "状況",
        "	DONo",
        "	SHIPPER",
        "	INVOICE No",
        "	ETA",
        "	TO",
        "	VESSEL",
        "	ｺﾝﾃﾅ No	",
        "ｺﾝﾃﾅｻｲｽﾞ",
        "	B/L No",
        "	P/N	",
        "品種名	",
        "QTY	",
        "最新 納入指示予定日",
        "最新 納入指示予定時間	",
        "最新 納入指示納入場所",
        "納入指示者希望日	",
        "納入指示者時間	",
        "納入指示者希望納入場所",
        "区分",
        "予約	",
        "時間指定	",
        "場所指定	",
        "納入指示者の注記",
        "第一受入確認者の注記	",
        "第二受入確認者の注記",
        "第一受入確認者確定日	",
        "第一受入確認者時間",
        "第一受入確認者確定納入場所",
        "第二受入確認者確定日",
        "第二受入確認者時間	",
        "第二受入確認者確定納入場所"
      ];
      this.$exportTable(packages, headers, showHeaders, "container");
      this.show = false;
    }
  }
};
</script>